export default "/images/info_icon.svg"